module.exports = __webpack_public_path__ + "static/media/energy.a6f02f79.jpg";